import { render, staticRenderFns } from "./Cognitivecomb.vue?vue&type=template&id=a80a2012&scoped=true"
import script from "./Cognitivecomb.vue?vue&type=script&lang=js"
export * from "./Cognitivecomb.vue?vue&type=script&lang=js"
import style0 from "./Cognitivecomb.vue?vue&type=style&index=0&id=a80a2012&prod&scoped=true&lang=css"
import style1 from "./Cognitivecomb.vue?vue&type=style&index=1&id=a80a2012&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80a2012",
  null
  
)

export default component.exports